import Home from "@/pages/website-landing/home/index"
import { FC } from "react"

/**
 * Wrapper component for root path (/) that serves Easetech home page
 * without requiring organization parameter in URL
 */
const RootHome: FC = () => {
  return <Home />
}

export default RootHome
